import { CompositeModel } from './composite.model';
import { NumberModel } from '../primitive/number.model';
import { TextModel } from '../primitive/text.model';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class EmailModel extends CompositeModel {
    public pos: NumberModel;
    public faxEmail: TextModel;
    public communicationCategory: TextModel;
    public constructor(pos: number, faxEmail: string, communicationCategory: string) {
        super('EmailModel');

        this.pos = <NumberModel>this.set(new NumberModel('Pos', pos));
        this.faxEmail = <TextModel>this.set(new TextModel('FaxEmail', faxEmail));
        this.communicationCategory = <TextModel>this.set(new TextModel('CommCat', communicationCategory));
    }

    public static fromOData(data: ODataEmailModel): EmailModel {
        return new EmailModel(data.Counter, data.FaxEmail, data.CommCategory);
    }
}

export interface ODataEmailModel extends ODataObject {
    Counter: number;
    FaxEmail: string;
    CommCategory: string;
    NotificationNo: string;
    TaskNumber: string;
    __metadata: {
        uri: string;
        id: string;
        type: 'HC_SM_NGM_58_SRV.Email';
    };
}
